/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Component, CircleDashed, Waves, Disc3, Wrench, Package } from 'lucide-react'

const categoryIcons = {
  brackets: Component,
  bands_and_tubes: CircleDashed,
  wires_and_springs: Waves,
  elastomerics: Disc3,
  orthodontic_pliers: Wrench,
  miscellaneous: Package,
}

const Categories = ({ category, setCategory }) => {
  const location = useLocation()

  const categories = [
    { id: 0, cat_id: "brackets", name: "Brackets" },
    { id: 1, cat_id: "bands_and_tubes", name: "Bands & Tubes" },
    { id: 2, cat_id: "wires_and_springs", name: "Wires & Springs" },
    { id: 3, cat_id: "elastomerics", name: "Elastomerics" },
    { id: 4, cat_id: "orthodontic_pliers", name: "Orthodontic Pliers" },
    { id: 5, cat_id: "miscellaneous", name: "Miscellaneous" }
  ]

  const handleCategoryClick = (selected) => {
    if (category === selected) setCategory("all")
    else setCategory(selected)
  }

  useEffect(() => {
    if (location.pathname === "/") setCategory("all")
  }, [location.pathname])

  return (
    <div className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-stretch overflow-x-auto md:overflow-visible md:justify-center rounded-xl border border-gray-100 bg-white shadow-sm divide-x divide-gray-100">
          {categories.map((item) => {
            const Icon = categoryIcons[item.cat_id]
            const isActive = category === item.name
            return (
              <Link
                key={item.id}
                to={`/category/${item.cat_id}`}
                onClick={() => handleCategoryClick(item.name)}
                className="group flex items-center justify-center gap-4 px-4 sm:px-6 py-3 flex-shrink-0 md:flex-1 whitespace-nowrap no-underline cursor-pointer"
              >
                <Icon
                  size={22}
                  strokeWidth={1.75}
                  className={`transition-colors ${isActive ? 'text-[#0094DA]' : 'text-gray-500 group-hover:text-[#0094DA]'}`}
                />
                <span
                  className={`!text-lg sm:text-base font-semibold transition-colors ${isActive ? 'text-[#0094DA]' : 'text-gray-700 group-hover:text-[#0094DA]'}`}
                >
                  {item.name}
                </span>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Categories
